import React, { useState } from "react";
import {
  ChantButton,
  DescriptionText,
  ScreenHeader,
} from "../../../CommonComponents";
import axios from "axios";
import moment from "moment";
import useAdminDataStore, { selectCurrentGroupData } from "../../../store/adminData/adminData";
import { toast } from "react-toastify";

const UpdateMatches = () => {
  const groupData = useAdminDataStore(selectCurrentGroupData);
  const [loading, setLoading] = useState(false);

  const handleUpdateMatches = async () => {
    try {
      setLoading(true);

      await axios.get(
        `${import.meta.env.VITE_GCP_BASE_URL}/addMatches?groupId=${groupData?.id}&session=${moment().year()}`
      );

      toast.success("Updated Successfully");
    } catch (error) {
      toast.error("Failed to update matches and tickets");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "12px" }}>
      <ScreenHeader title="Update Match Listing" />

      <DescriptionText showBackground>
        Click the button below to refresh the schedule in the Tickets section of
        the app (if missing future matches or has incorrect dates/times). If
        Tickets section is the same as Schedule (and both appear incorrectly)
        the underlying match feed is incorrect. Check back in a few days
        (usually updated in a timely manner) or reach out to support@chant.fan.
      </DescriptionText>
      <div
        style={{
          padding: "12px",
          backgroundColor: "var(--primary-dashboard-background)",
          marginTop: "2px",
          height: "80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <ChantButton
          loading={loading}
          disabled={loading}
          type="primary"
          className="default-text-color"
          onClick={handleUpdateMatches}
        >
          Update Match Listing
        </ChantButton>
      </div>
    </div>
  );
};

export default UpdateMatches;
